import { render, staticRenderFns } from "./BoxIndicadores.vue?vue&type=template&id=227bda9c&scoped=true&"
import script from "./BoxIndicadores.vue?vue&type=script&lang=js&"
export * from "./BoxIndicadores.vue?vue&type=script&lang=js&"
import style0 from "./BoxIndicadores.vue?vue&type=style&index=0&id=227bda9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227bda9c",
  null
  
)

export default component.exports